import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import sessionService from "services/SessionService";


export const createSession = createAsyncThunk('session/createSession', async (data, { rejectWithValue }) => {
    const { key, title, description, examId, date, parent, type, questions, time, marks, instructions } = data
	try {
		const response = await sessionService.createSession({ key, title, description, examId, date, parent, type, questions, time, marks, instructions})
		return response.data
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Error')
	}
})

export const getSession = createAsyncThunk('session/getSession', async (data, { rejectWithValue }) => {
    const { examId, sessionId } = data
	try {
		const response = await sessionService.getSession({examId, sessionId})
		return response.data
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Error')
	}
})

export const getSessionQuestions = createAsyncThunk('session/questions', async (data, { rejectWithValue }) => {
    
	const { sessionId } = data
	try {
		const response = await sessionService.getQuestions({sessionId})
		return response.data
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Error')
	}
})

export const getSessionAnswers = createAsyncThunk('session/answers', async (data, { rejectWithValue }) => {
    
	const { sessionId } = data
	try {
		const response = await sessionService.getAnswers({sessionId})
		return response.data
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Error')
	}
})

export const getSessionSections = createAsyncThunk('session/sections', async (data, { rejectWithValue }) => {
	const { sessionId } = data
	try {
		const response = await sessionService.getSections({sessionId})
		return response.data
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Error')
	}
})

export const getQuestionVariant = createAsyncThunk('session/questionVariant', async (data, { rejectWithValue }) => {
    
	const { sessionId, questionId } = data
	try {
		const response = await sessionService.getQuestionVariant({sessionId, questionId})
		return response.data
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Error')
	}
})

export const getAnswer = createAsyncThunk('session/questionAsnwer', async (data, { rejectWithValue }) => {
    
	const { sessionId, questionId } = data
	try {
		const response = await sessionService.getAnswer({sessionId, questionId})
		return response.data
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Error')
	}
})

export const createQuestion = createAsyncThunk('session/createQuestion', async (data, { rejectWithValue }) => {
    const { subjectKey, topicKey, difficulty, markingScheme, type,
        question, imgUrl, optionA, optionB, optionC,optionD,
        examId, sessionId, sectionKey, correct, incorrect, partial,
        key } = data
	try {
		const response = await sessionService.postQuestion({key, subjectKey, topicKey, difficulty, markingScheme, type,
            question, imgUrl, options: [ 
                { text: optionA, sequence: 0},
                { text: optionB, sequence: 1},
                { text: optionC, sequence: 2},
                { text: optionD, sequence: 3}
            ],
            marking:{
                correct,
                incorrect, 
                partial
            },
            examId, sessionId, sectionKey})
		return response.data
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Error')
	}
})

export const createAnswer = createAsyncThunk('session/createAnswer', async (data, { rejectWithValue }) => {
    const { subjectKey, topicKey, 
        answer, explanation, imgUrl, 
        examId, sessionId, questionId, sectionKey} = data
	try {
		const response = await sessionService.postAnswer({subjectKey, topicKey, 
            answer, explanation, imgUrl,
            examId, sessionId, questionId, sectionKey})
		return response.data
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Error')
	}
})

export const createSection = createAsyncThunk('session/createSection', async (data, { rejectWithValue }) => {
    const { key, title, description, sequence, questionCount, maxAttempt, sessionId, instructions } = data
	try {
		const response = await sessionService.postSection({ key, title, description, sequence, questionCount, maxAttempt, sessionId, instructions })
		return response.data
	} catch (err) {
		return rejectWithValue(err.response?.data?.message || 'Error')
	}
})

export const initialState = {
    status: 'idle',
    error: null,
    sessionQuestions: {},
    sessionAnswers: {},
    sessionSections: {},
    questionVariant: {},
    questionAnswer: {},
    session: {}
}

export const sessionSlice = createSlice({
    name: 'session',
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
        .addCase(createSession.pending, (state) => {
            state.status = 'loading'
        })
        .addCase(createSession.fulfilled, (state, action) => {
            state.status = 'success'
        })
        .addCase(createSession.rejected, (state, action) => {
            state.status = 'failure'
            state.error = action.error.message
        })
        .addCase(getSession.pending, (state) => {
            state.status = 'loading'
        })
        .addCase(getSession.fulfilled, (state, action) => {
            state.status = 'success'
            state.session = action.payload
        })
        .addCase(getSession.rejected, (state, action) => {
            state.status = 'failure'
            state.error = action.error.message
        })
        .addCase(createQuestion.pending, (state) => {
            state.status = 'loading'
        })
        .addCase(createQuestion.fulfilled, (state, action) => {
            state.status = 'success'
        })
        .addCase(createQuestion.rejected, (state, action) => {
            state.status = 'failure'
            state.error = action.error.message
        })
        .addCase(createAnswer.pending, (state) => {
            state.status = 'loading'
        })
        .addCase(createAnswer.fulfilled, (state, action) => {
            state.status = 'success'
        })
        .addCase(createAnswer.rejected, (state, action) => {
            state.status = 'failure'
            state.error = action.error.message
        })
        .addCase(getQuestionVariant.pending, (state) => {
            state.status = 'loading'
            state.questionVariant = {}
        })
        .addCase(getQuestionVariant.fulfilled, (state, action) => {
            state.status = 'success'
            state.questionVariant = action.payload
        })
        .addCase(getQuestionVariant.rejected, (state, action) => {
            state.status = 'failure'
            state.error = action.error.message
        })
        .addCase(getAnswer.pending, (state) => {
            state.status = 'loading'
            state.questionAnswer = {}
        })
        .addCase(getAnswer.fulfilled, (state, action) => {
            state.status = 'success'
            state.questionAnswer = action.payload
        })
        .addCase(getAnswer.rejected, (state, action) => {
            state.status = 'failure'
            state.error = action.error.message
        })
        .addCase(getSessionQuestions.pending, (state) => {
            state.status = 'loading'
        })
        .addCase(getSessionQuestions.fulfilled, (state, action) => {
            state.status = 'success'
            state.sessionQuestions = action.payload
        })
        .addCase(getSessionQuestions.rejected, (state, action) => {
            state.status = 'failure'
            state.error = action.error.message
        })
        .addCase(getSessionAnswers.pending, (state) => {
            state.status = 'loading'
        })
        .addCase(getSessionAnswers.fulfilled, (state, action) => {
            state.status = 'success'
            state.sessionAnswers = action.payload
        })
        .addCase(getSessionAnswers.rejected, (state, action) => {
            state.status = 'failure'
            state.error = action.error.message
        })
        .addCase(createSection.pending, (state) => {
            state.status = 'loading'
        })
        .addCase(createSection.fulfilled, (state, action) => {
            state.status = 'success'
        })
        .addCase(createSection.rejected, (state, action) => {
            state.status = 'failure'
            state.error = action.error.message
        })
        .addCase(getSessionSections.pending, (state) => {
            state.status = 'loading'
            state.sessionSections = {}
        })
        .addCase(getSessionSections.fulfilled, (state, action) => {
            state.status = 'success'
            state.sessionSections = action.payload
        })
        .addCase(getSessionSections.rejected, (state, action) => {
            state.status = 'failure'
            state.error = action.error.message
        })
       
    }
})

export default sessionSlice.reducer

export const selectSession = state => state.session.session
export const selectSessionQuestions = state => state.session.sessionQuestions
export const selectSessionAnswers = state => state.session.sessionAnswers
export const selectSessionSections = state => state.session.sessionSections
export const selectQuestionVariant = state => state.session.questionVariant
export const selectQuestionAnswer = state => state.session.questionAnswer
export const selectSessionStatus = state => state.session.status